/*
  Turns "name [at] domain.com" text into a working mailto link in the browser, so the raw
  address never sits in the page source. Used on Shopify policy pages (the Contact
  information policy) and inside any element marked data-email-assemble.
  Without JavaScript the readable "name [at] domain.com" text stays as it is.
*/
(function () {
  var pattern = /([A-Za-z0-9._%+-]+) \[at\] ([A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+)/g;

  function assemble(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (node.parentNode && node.parentNode.closest('a, script, style')) continue;
      pattern.lastIndex = 0;
      if (pattern.test(node.nodeValue)) nodes.push(node);
    }

    nodes.forEach(function (node) {
      var text = node.nodeValue;
      var fragment = document.createDocumentFragment();
      var last = 0;
      var match;
      pattern.lastIndex = 0;
      while ((match = pattern.exec(text)) !== null) {
        fragment.appendChild(document.createTextNode(text.slice(last, match.index)));
        var address = match[1] + '@' + match[2];
        var link = document.createElement('a');
        link.href = 'mailto:' + address;
        link.textContent = address;
        fragment.appendChild(link);
        last = match.index + match[0].length;
      }
      fragment.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(fragment, node);
    });
  }

  function run() {
    document.querySelectorAll('.shopify-policy__body, [data-email-assemble]').forEach(assemble);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
